import { useSelector, useDispatch } from "react-redux";
import { submitOrder } from "../../store/actions/image";
import { closeModal, setNav } from "../../store/actions/app";
import { DESIGN_VIEW, MOCKUP_VIEW } from "../../constants/constants"

// Flow control buttons - cancel, continue
const OrderFlowControl = () => {
  const dispatch = useDispatch();
  const pages = useSelector(({ image }) => image.pages);
  const indexSelected = useSelector(({ app }) => app.indexSelected);

  // close modal if in design view, otherwise navigate back
  const close = () => {
    if (indexSelected === DESIGN_VIEW) {
      dispatch(closeModal());
    } else {
      dispatch(setNav(DESIGN_VIEW))
    }
  };

  // next view or submit
  const onClick = () => {
    if (indexSelected === DESIGN_VIEW) {
      if (pages && pages.length && pages.some(p => p.json && p.json.objects && p.json.objects.length)){
        dispatch(setNav(MOCKUP_VIEW))
      } else {
        alert("The canvas is blank. Please create or upload a design first")
      }
    } else {
      if (window.confirm("Are you sure? Your design will not be saved."))
      {
        dispatch(submitOrder())
      }
    }
  }

  return (
    <footer className="mm-pod-sidebar-footer">
      <div className="row mx-n1">
        <div className="col-auto px-1">
          <button className="btn btn-link" onClick={close}>
          {indexSelected === DESIGN_VIEW ? "Cancel" : "Previous"}
          </button>
        </div>
        <div className="col px-1">
          <button
            className={`btn btn-secondary btn-block`}
            onClick={onClick}
          >
            {indexSelected === DESIGN_VIEW ? "Preview" : "Submit"}
          </button>
        </div>
      </div>
    </footer>
  );
};

export default OrderFlowControl;
